import React, { Component } from 'react';
//import ScrollAnimation from 'react-animate-on-scroll';
//import Asset21 from '../Assets/img/Asset-21.png';
//import Asset16 from '../Assets/img/Asset-16.png';
//import Asset17 from '../Assets/img/Asset-17.png';
//import SchoolEasy_module from '../Assets/img/SchoolEasy-module.png';
//import SchoolEasy_new_module from '../Assets/img/SchoolEasy-new-module.png';

export class SchoolEasy extends Component {
    render() {
        return (
            <div>
                <div className="benifits_school" id="feature">
                    <div className="container">
                        <div className="row align-items-center py-lg-5 py-4">
                        {/* <img src={SchoolEasy_new_module} className="img-fluid" /> */}
                        <div className='table-responsive pricing-table pt-3'>
                        <table className="table table-bordered table-strip">
                        <tr>
                            <th style={{fontWeight:600,fontSize:'22px',textAlign:'left',padding:'8px',width:'55%'}}>Features</th>
                            
                            <th style={{fontWeight:600,fontSize:'22px',width:'15%'}}>Basic</th>
                            <th style={{fontWeight:600,fontSize:'22px',width:'15%'}}>Pro</th>
                            <th style={{fontWeight:600,fontSize:'22px',width:'15%'}}>Ultra</th>
                        </tr>
                        
                        <tr>
                            <td style={{textAlign:'left'}}>ERP Login</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Web Hosting + CMS Login</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Basic Website Domain (non https) - if opted</td>
                            
                            <td style={{fontWeight:600,fontSize:'14px'}}>Charged Extra</td>
                            <td style={{fontWeight:600,fontSize:'14px'}}>Charged Extra</td>
                            <td style={{fontWeight:600,fontSize:'14px'}}>Charged Extra</td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>HTTPS Website Domain (SSL) - if opted</td>
                            
                            <td style={{fontWeight:600,fontSize:'14px'}}>Charged Extra</td>
                            <td style={{fontWeight:600,fontSize:'14px'}}>Charged Extra</td>
                            <td style={{fontWeight:600,fontSize:'14px'}}>Charged Extra</td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Website Customized Themes</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>School Data Configuration/Management</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Admission Management (+ Import) & Reports</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Fee Management (offline) & Reports</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Online Fees - Payment Gateway Integration</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Basic Online Attendance Management</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                         <tr>
                            <td style={{textAlign:'left'}}>Biometric Attendance for Staff
                            (API support for device:- BioMax N - E90 Pro) </td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Gate Pass (Visitor Management)</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>LMS (Learning Management System)</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Microsoft Teams</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Online Exams (MCQ)</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Result (Progress Report) + Customized Templates</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Certificates (TC, Character Certificate)</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Android App (School/Parents)</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Payroll (Salary Slip/Deductions/ESIC/PF)</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Leave Management (HRM)</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Library Management</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Transport Management (without GPS)</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Query & Doubt Management</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Complaint Management</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        
                         <tr>
                            <td style={{textAlign:'left'}}>Extra-Curricular Management</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Tech Support Mechanism</td>
                            
                            <td style={{fontSize:'14px'}}> Email </td>
                            <td style={{fontSize:'14px'}}>Email/Phone/Remote</td>
                            <td style={{fontSize:'14px'}}>Email/Phone/Remote</td>
                            
                        </tr>
                        <tr>
                            <td style={{textAlign:'left'}}>Tech Support Issue Tracking (Ticket System)</td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr >
                            <td style={{textAlign:'left'}}>Training for School Staff (Online Mode)</td>
                            
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr >
                            <td style={{textAlign:'left'}}>Training for School Staff (On Site)</td>
                            
                            <td style={{fontSize:'14px'}}> </td>
                            <td style={{fontSize:'14px'}}>2 times/year</td>
                            <td style={{fontSize:'14px'}}>4 times/year</td>
                        </tr>
                        <tr >
                            <td style={{textAlign:'left'}}>Inventory (Assets) Management</td>
                            
                            <td></td>
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        <tr id="price">
                            <td style={{textAlign:'left'}}>Accounts Management/ Bookkeeping Module (Payment/Receipts/Journals/Contra) </td>
                            
                            <td></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                            <td><i class="fa fa-check" aria-hidden="true"></i></td>
                        </tr>
                        
                    <tr><td style={{textAlign:'left', background:'#fff', color:'rgba(212, 5, 5, 0.786)'}} colSpan={5}>Note 1 - For exact plan prices - kindly contact - <a href='mailto:bishalc@rkcl.in'>bishalc@rkcl.in</a> we only charge flat annual rates irrepsective of student count. Hence no hassles of per student pricing.</td></tr>
                    <tr><td style={{textAlign:'left', background:'#fff', color:'rgba(212, 5, 5, 0.786)'}} colSpan={5}>Note 2 - There is No Refund Policy.</td></tr>
                    <tr><td style={{textAlign:'left', background:'#fff', color:'rgba(212, 5, 5, 0.786)'}} colSpan={5}>Note 3 - All payments to be made in advance via UPI ID/UPI QR/NEFT mode to RKCL Bank Account in advance. We do not accept Cash/DD/Cheque. Payment page link - <a href='https://schooleasyerp.com/payment'>https://schooleasyerp.com/payment</a></td></tr>
                    <tr><td style={{textAlign:'left', background:'#fff', color:'rgba(212, 5, 5, 0.786)'}} colSpan={5}>Note 4 - Once a Plan is purchased by School, we dont allow change of Plan for next 365 days. Plan upgrade is only possible after 1 year.</td></tr>
                    {/*<tr><td style={{textAlign:'left'}} colSpan={5}>
                        <p><b><u>SchoolEasy payment to be done on following RKCL bank account</u></b> -<br/>
                        <b>Account Holder Name -</b> Rajasthan Knowledge Corporation Ltd.<br/>
                        <b>Account Number -</b> 911020042604401<br/>
                        <b>IFSC Code -</b> UTIB0000031<br/>
                        <b>Bank Name -</b> Axis Bank, Tilak Nagar, Jaipur</p>
                    </td></tr>*/}
                    </table>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SchoolEasy
